// extracted by mini-css-extract-plugin
module.exports = {"list":"Tabs_list__2OTa0","tab":"Tabs_tab__2ALt8","selected":"Tabs_selected__10nNl"};